// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__p51b5","inputDescription":"styles_inputDescription__3Lkz_"};